var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 152 152",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10.linkedin",
    "data-name": "10.linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76 0a76 76 0 1 0 76 76 76 76 0 0 0 -76-76zm-19.34 111.43a2.57 2.57 0 0 1 -2.57 2.57h-10.92a2.56 2.56 0 0 1 -2.57-2.57v-45.79a2.57 2.57 0 0 1 2.57-2.57h10.92a2.57 2.57 0 0 1 2.57 2.57zm-8-52.67a10.38 10.38 0 1 1 10.34-10.39 10.38 10.38 0 0 1 -10.37 10.39zm65.12 52.88a2.36 2.36 0 0 1 -2.36 2.36h-11.75a2.36 2.36 0 0 1 -2.36-2.36v-21.48c0-3.21.93-14-8.38-14-7.22 0-8.69 7.42-9 10.75v24.78a2.36 2.36 0 0 1 -2.34 2.31h-11.34a2.35 2.35 0 0 1 -2.36-2.36v-46.2a2.36 2.36 0 0 1 2.36-2.37h11.34a2.37 2.37 0 0 1 2.41 2.37v4c2.68-4 6.66-7.13 15.13-7.13 18.78 0 18.67 17.54 18.67 27.17z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.88012d347ef952f130afb65f121bd23c.svg";
export { ForwardRef as ReactComponent };